<template>
  <div v-html="svgIcon"></div>
</template>

<script>
import svgPath from "@/util/svgPath";

export default {
  name: "svg-icons",

  props: {
    svgId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    svgIcon: "",
  }),

  mounted() {
    this.svgIcon = svgPath(this.svgId);
  },
};
</script>

<style>
svg path {
  fill: var(--v-primary-base);
}
</style>